module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Você concluiu todas as etapas!","subtitle":"Aproveite as funcionalidades disponíveis e impulsione suas vendas com segurança.","button":"Começar a usar"},"en-US":{"title":"You have completed all steps!","subtitle":"Take advantage of the available features and boost your sales safely.","button":"Get Started"}}')
  delete Component.options._Ctor
}
